import { useCallback, useEffect, useState } from 'react';
import { IRoomStreaming } from '../../../redux/streamGoApi';
import { FormContainer, StyledTextField } from './styled';

export interface IStreamingUrlForm {
  formData: IRoomStreaming;
  isSubmitting: boolean;
  onFieldChange: (field: keyof IRoomStreaming, value: string) => void;
  onValidationChange?: (isValid: boolean) => void;
}

const STREAMING_URL_REGEX = /^rtmps?:\/\/.+/i;

const errorStyle = {
  color: 'white!important',
  background: '#d3302f',
  fontWeight: 'bold',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  padding: '8px',
  margin: '8px 0 0 0',
};

export const StreamingUrlForm = ({
  formData,
  isSubmitting,
  onFieldChange,
  onValidationChange,
}: IStreamingUrlForm) => {
  const [urlError, setUrlError] = useState<string>('');

  const createChangeHandler = useCallback(
    (field: keyof IRoomStreaming) =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        onFieldChange(field, value);
      },
    [onFieldChange],
  );

  useEffect(() => {
    const hasUrlError =
      formData.StreamingUrl && !STREAMING_URL_REGEX.test(formData.StreamingUrl);
    const isValid =
      !hasUrlError && !!formData.Description && !!formData.StreamingUrl;

    if (hasUrlError) {
      setUrlError('URL must start with rtmp:// or rtmps://');
    }

    onValidationChange?.(isValid);
  }, [formData, onValidationChange]);

  return (
    <FormContainer>
      <StyledTextField
        autoComplete="false"
        fullWidth={true}
        label="Description"
        onChange={createChangeHandler('Description')}
        required={true}
        size="small"
        value={formData.Description}
      />
      <StyledTextField
        autoComplete="false"
        error={isSubmitting && !!urlError}
        FormHelperTextProps={{
          sx: errorStyle,
        }}
        fullWidth={true}
        helperText={isSubmitting ? urlError : null}
        label="Streaming URL"
        onChange={createChangeHandler('StreamingUrl')}
        placeholder="rtmps://stream.example.com/live"
        required={true}
        size="small"
        value={formData.StreamingUrl}
      />
      <StyledTextField
        autoComplete="false"
        fullWidth={true}
        label="Streaming Key (Optional)"
        onChange={createChangeHandler('StreamingKey')}
        size="small"
        type="text"
        value={formData.StreamingKey}
      />
    </FormContainer>
  );
};
